var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.36569 0.234315C1.05327 -0.0781049 0.546734 -0.0781049 0.234315 0.234315C-0.0781049 0.546734 -0.0781049 1.05327 0.234315 1.36569L3.66863 4.8L0.234315 8.23431C-0.0781049 8.54673 -0.0781049 9.05327 0.234315 9.36569C0.546734 9.67811 1.05327 9.67811 1.36569 9.36569L4.8 5.93137L8.23431 9.36569C8.54673 9.67811 9.05327 9.67811 9.36569 9.36569C9.67811 9.05327 9.67811 8.54673 9.36569 8.23431L5.93137 4.8L9.36569 1.36569C9.67811 1.05327 9.67811 0.546734 9.36569 0.234315C9.05327 -0.0781049 8.54673 -0.0781049 8.23431 0.234315L4.8 3.66863L1.36569 0.234315Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/closeX.b7c928d3e8536b82528ffc13001beff4.svg";
export { ForwardRef as ReactComponent };